import React, { useState, useImperativeHandle, forwardRef } from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom'

//images
import greatImg from '../../../assets/images/success/great-img.jpg';

function CompletedTest(props, ref) {

    const [major, setMajor] = useState({
        blur: false,
        popup: false,
        href: '',
    })

    useImperativeHandle(ref, () => ({
        open: href => {
            handleOpen(href)
        },
        close: () => {
            handleClose()
        }
    }))

    const handleOpen = href => {
        setMajor(major => ({
            ...major,
            blur: true,
            href: href
        }))
        setTimeout(() => {
            setMajor(major => ({
                ...major,
                popup: true
            }))
        }, 50);
    }

    const handleClose = () => {
        setMajor(major => ({
            ...major,
            popup: false
        }))
        setTimeout(() => {
            setMajor(major => ({
                ...major,
                blur: false,
            }))
        }, 100)
    }

    return (
        <div id="overlay" className={major.blur ? 'visible' : ''}>
            <div className={`box complete-test ${major.popup ? 'show' : ''}`}>
                <img src={greatImg} className="main-img" />
                <h3>
                    Гледай Видео лекциите от Тема 1
                </h3>
                <p>
                    Справяш се страхотно! За да затвърдиш своите знания изгледай всички видео лекции от Тема 1.
                </p>
                <div className="buttons">
                    <Button>
                        <Link to="/topic?topic_id=1&video_id=o59AvgSd">
                            Към Видео Лекциите
                        </Link>
                    </Button>
                </div>
            </div>
        </div >
    )
}

export default forwardRef(CompletedTest);